<div (click)="this.closeModalAndEmptyCart()"></div>

@if (offers) {
  <div>
    <div class="modal-container">
      <!-- Modal Header -->
      <div class="modal-header">
        <p></p>
        <div class="button-close" (click)="closeModalAndEmptyCart()" style="transform: translate(5px, -1px); ">
          <img [src]="themeService.isDarkMode() ? 'assets/svg/close-70-black.svg' : 'assets/svg/close-70.svg'" class="image-close" style="transform: translate(-5px, -3px);"/>
        </div>
      </div>
      <!-- Modal Body -->
      <div class="modal-body-wrapper">
        <div class="modal-body-content">
          <div class="terms-content">
            <p class="terms-txt">Dear Guest,</p>
            <!-- Single Offer -->
            <div>
              <p class="terms-txt">
                Thank you for your upgrade request for an additional {{calculateTotalPrice(offers) | currency:'USD' }}, plus tax. This fee will be added to your current room rate.
              </p>
            </div>
            <!-- Multiple Offers -->
            <div>
              <app-shopping-cart-table
                [offers]="offers"
                [offerAliasId]="offerAliasId"
                [propertyId]="propertyId"
                (remove)="removeOfferFromCart({ offer: $event.offer, aliasId: $event.aliasId })">
              </app-shopping-cart-table>
          </div>
          <!-- Static Policy Section -->
          <p class="terms-txt terms-txt-bold">Here's what happens next:</p>
          <div class="terms-list-item">
            <li></li>
            <p class="terms-txt">
              <span class="terms-txt-bold">Review: </span> The property team will review your request typically within 24 hours.
            </p>
          </div>
          <div class="terms-list-item">
            <li></li>
            <p class="terms-txt">
              <span class="terms-txt-bold">Notification: </span>{{getNotification(offers[0].confirmation_type || 'E')}}
            </p>
          </div>
          <div class="terms-list-item">
            <li></li>
            <p class="terms-txt">
              <span class="terms-txt-bold">Policy: </span>Once accepted, the charge is non-refundable, so please ensure it aligns with your plans.
            </p>
          </div>
          <p class="terms-txt">We appreciate your stay with us and look forward to making your visit special.</p>
          <p class="terms-txt">Warm regards,</p>
          <p class="terms-txt">{{offers[0].prop_name | titlecase}}</p>
        </div>
      </div>
    </div>
    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="footer-wrapper" [lxResponsiveClass]="{ horizontal: 'd-flex', vertical: 'd-block' }">

        <label class="acknowledgment-label">
          <div class="acknowledgment-content" style="margin-left: auto; margin-right: 0px; float: right;"
            [lxResponsiveClass]="{ horizontal: 'modal-footer-desktop', vertical: 'modal-footer-handset' }">
            <span class="acknowledgment-text"
                  [lxResponsiveClass]="{ horizontal: 'modal-footer-desktop', vertical: 'modal-footer-handset' }">
              I understand and agree to the upgrade terms.
              <span class="checkmark"></span>
                &nbsp;
                <input *lxViewport="'vertical'" class="checkbox-vertical" type="checkbox" (click)="toggleAcknowledgment()">
            </span>
            <input *lxViewport="'horizontal'" class="checkbox-horizontal" type="checkbox" (click)="toggleAcknowledgment()">
          </div>
        </label>

        <button data-dismiss="modal" type="button" class="button-request button-request-terms"
          [class.button-disabled-opacity]="!this.acknowledgment"
          [lxResponsiveClass]="{ horizontal: 'modal-footer-desktop', vertical: 'modal-footer-handset' }"
          (click)="this.acceptOffer()">Request Upgrade
        </button>

      </div>
  </div>
</div>
</div>
}
